import { Analytics } from "@segment/analytics-node";
import { WriteKeyMap } from "./utils";
import { AnalyticsInstance, EventProperties } from "./Analytics";
import packageInfo from "package.json";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import { getEnvironmentConfig } from "~/modules/config";
import { getLogger, LoggerName, Logger } from "~/modules/logger";
import { getOrigin } from "~/utils/getOrigin";
import { parseRegionForAnalytics } from "~/utils/regionUtil";

export class AnalyticsImpl implements AnalyticsInstance {
    private analytics: Analytics;

    private commonProperties: EventProperties;

    private disabled: boolean = false;

    private readonly clientOptions: ClientOptionsStore;

    private readonly logger: Logger;

    constructor(ctx: ContextManager) {
        this.clientOptions = ctx.retrieveInstanceOf(ContextInstance.ClientOptionsStore, ClientOptionsStore);
        this.logger = getLogger(ctx)(LoggerName.Analytics);
    }

    









    public init(telemetryDisabled: boolean, writeKeyMap?: WriteKeyMap): void {
        try {
            if (telemetryDisabled) {
                this.disabled = true;
                return;
            }

            const environmentConfig = getEnvironmentConfig();
            const { region } = environmentConfig ?? {};
            const configRegion = region ?? this.clientOptions.region ?? "us1";
            const env = parseRegionForAnalytics(configRegion);
            const writeKey = writeKeyMap?.analytics?.[env] ?? writeKeyMap?.analytics?.prod ?? undefined;

            if (!writeKey) {
                this.logger.warn("FlexSDK Telemetry Key not found. The FlexSDK Telemetry will be disabled.");
                this.disabled = true;
                return;
            }

            const origin = getOrigin();
            const flexUiVersion = origin === "flexui" && this.clientOptions.appVersion;
            
            
            const hostRegion = env === "prod" ? "us1" : `stage-us1`;

            this.analytics = new Analytics({
                writeKey,
                host: `https://api.flexsdkanalytics.${hostRegion}.twilio.com/v1`
            });
            this.commonProperties = {
                product: "Flex",
                source: "flexsdk",
                realm: configRegion,
                flexSdkVersion: packageInfo.version,
                origin,
                ...(flexUiVersion && { flexUiVersion })
            };
        } catch (e) {
            this.logger.warn("Failed to initialise FlexSDK Analytics", e);
            this.disabled = true;
        }
    }

    public track = (eventName: string, eventProperties?: EventProperties): void => {
        if (this.disabled) {
            return;
        }

        if (!this.analytics) {
            this.logger.warn("Analytics is not initialized");
            return;
        }

        try {
            this.analytics.track({
                
                userId: eventProperties?.userId,
                
                anonymousId: eventProperties?.anonymousId,
                event: eventName,
                properties: { ...this.commonProperties, ...eventProperties }
            });
        } catch (err) {
            this.logger.warn(err);
        }
    };
}
